<template>
  <Modal
    class="cc-modal"
    width="800"
    footer-hide
    v-model="visibility"
    :title="`${data ? data.name : ''}-模板详情`"
  >
    <div class="content" v-if="data">
      <div class="row">
        <div class="name">用户类型:</div>
        <div class="label">{{ data.type === 0 ? "个人" : "企业" }}</div>
      </div>
      <template v-if="data.type !== 0">
        <div class="row">
          <div class="name">企业名称（中文）:</div>
          <div class="label">{{ data.locBusinessName }}</div>
        </div>
        <div class="row">
          <div class="name">企业名称（英文）:</div>
          <div class="label">{{ data.intBusinessName }}</div>
        </div>
      </template>
      <div class="row">
        <div class="name">域名所有者（中文）:</div>
        <div class="label">
          {{
            data.type === 0 ? data.locName : data.locBusinessName
          }}
        </div>
      </div>
      <div class="row">
        <div class="name">域名所有者（英文）:</div>
        <div class="label">
          {{
            data.type === 0 ? data.intName : data.intBusinessName
          }}
        </div>
      </div>
      <div class="row">
        <div class="name">联系人（中文）:</div>
        <div class="label">{{ data.locName }}</div>
      </div>
      <div class="row">
        <div class="name">联系人（英文）:</div>
        <div class="label">{{ data.intName }}</div>
      </div>
      <div class="row">
        <div class="name">电子邮箱:</div>
        <div class="label">{{ data.email }}</div>
      </div>
      <div class="row">
        <div class="name">地区:</div>
        <div class="label">
          {{
            `${data.country ? data.country + ", " : ""}${
              data.locSp ? data.locSp + ", " : ""
            }${data.locCity ? data.locCity + ", " : ""}${
              data.locStreet ? data.locStreet : ""
            }`
          }}
        </div>
      </div>
      <div class="row">
        <div class="name">通信地址（中文）:</div>
        <div class="label">{{ data.locStreet2 }}</div>
      </div>
      <div class="row">
        <div class="name">邮编:</div>
        <div class="label">{{ data.postcode }}</div>
      </div>
      <div class="row">
        <div class="name">手机:</div>
        <div class="label">{{ data.phone }}</div>
      </div>
      <div class="row">
        <div class="name">联系人（英文）:</div>
        <div class="label">{{ data.intName }}</div>
      </div>
    </div>
    <div class="foot">
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: "templateInfoModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
</style>
